var map = {
	"./celebrity.webm": "d710",
	"./check-users.webm": "5556",
	"./gpt.webm": "0cb3",
	"./image.webm": "7248",
	"./messages.webm": "886f",
	"./person-description.webm": "f399",
	"./person-recommendations.webm": "8b9e",
	"./professional.webm": "4c81",
	"./psychotype.webm": "9359",
	"./recommendations.webm": "318a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1411";